import script from "./Bistroopage.vue?vue&type=script&setup=true&lang=js"
export * from "./Bistroopage.vue?vue&type=script&setup=true&lang=js"

import "./Bistroopage.vue?vue&type=style&index=0&id=7a5c963e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a5c963e"]])

export default __exports__